import { WarningModal } from '@/shared/components/WarningModal';
import useBoolean from '@/shared/hooks/useBoolean';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import { useStateChainAccount } from './useStateChainAccount';
import useStore from './useStore';

export default function useDisconnectWithWarning() {
  const { account } = useStateChainAccount();
  const { selectedAccount, disconnect } = usePolkadot();
  const storeRefundAddresses = useStore((state) => state.refundAddresses);

  const { value: isWarningOpen, setTrue: openWarning, setFalse: closeWarning } = useBoolean(false);

  const hasUnsavedRefundAddresses =
    !account &&
    selectedAccount?.type === 'evm' &&
    Object.values(storeRefundAddresses).some(Boolean);

  return {
    disconnect: hasUnsavedRefundAddresses ? openWarning : disconnect,
    disconnectWarning: (
      <WarningModal
        isOpen={isWarningOpen}
        onClose={closeWarning}
        onAccept={() => {
          closeWarning();
          disconnect();
        }}
        title="Your refund address settings will be lost"
        content={
          <>
            If you disconnect your wallet or leave the App before completing account setup with your
            first deposit, your refund address settings will be lost. You’ll need to set them up
            again when you return.
          </>
        }
      />
    ),
  };
}
